import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightbulb = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.25 18.25H8.75M15.25 7.49281V7C15.25 4.1005 12.8995 1.75 10 1.75C7.10051 1.75 4.75 4.1005 4.75 7V7.49281C4.75 9.21535 5.61088 10.8239 7.04412 11.7794C7.48511 12.0734 7.75 12.5684 7.75 13.0984V14.682C7.75 14.9957 8.00431 15.25 8.31802 15.25H11.682C11.9957 15.25 12.25 14.9957 12.25 14.682V13.0984C12.25 12.5684 12.5149 12.0734 12.9559 11.7794C14.3891 10.8239 15.25 9.21535 15.25 7.49281Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgLightbulb);
export { ForwardRef as ReactComponent };
